export default class TweetService {
  constructor(http, socket) {
    this.http = http;
    this.socket = socket;
  }

  async getTweets(username) {
    const query = username ? `?username=${username}` : "";

    return this.http.fetch(`/tweets${query}`, {
      // fetch(): 원래 http가 제공하는 메서드
      // this.http.fetch(): 내가 만든 메서드
      method: "GET",
    }); // fetch로 서버에서 res 가져오기 - fetch 비동기라서 필요
  }

  async postTweet(text) {
    return this.http.fetch(`/tweets`, {
      method: "POST",
      body: JSON.stringify({ text }), // JS객체 -> json(텍스트)
    });
  }

  async updateTweet(tweetId, text) {
    return this.http.fetch(`/tweets/${tweetId}`, {
      method: "PUT",
      body: JSON.stringify({ text }),
    });
  }

  async deleteTweet(tweetId) {
    return this.http.fetch(`/tweets/${tweetId}`, {
      method: "DELETE",
    });
  }

  // onSync(callback) {
  //   // 새로운 트윗 생겼을 때 하고싶은 일을 callback으로 전달
  //   return this.socket.onSync("tweets", callback);
  // }

  // 1. 생성 감지 (tweets-created)
  onCreated(callback) {
    return this.socket.onSync("tweets-created", callback);
  }

  // 2. 수정 감지 (tweets-updated)
  onUpdated(callback) {
    return this.socket.onSync("tweets-updated", callback);
  }

  // 3. 삭제 감지 (tweets-deleted)
  onDeleted(callback) {
    return this.socket.onSync("tweets-deleted", callback);
  }
}
